import { render, staticRenderFns } from "./AppointmentDate.vue?vue&type=template&id=8802cf50&"
import script from "./AppointmentDate.vue?vue&type=script&lang=js&"
export * from "./AppointmentDate.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports